module.exports = __webpack_public_path__ + "static/media/1_pl.87c683a5.png";